// extracted by mini-css-extract-plugin
module.exports = {"items":"_4eWxks","image":"_23Zti2","item":"_2-W3UV","button":"_39_izF","empty":"_2mLAGw","modal":"msZ4Sf","title":"_2m0Njv","product":"jjw6LX"};